package top.wcpe.allincore.dsl.compiler.ast

import top.wcpe.allincore.dsl.compiler.source.SourcePosition

/**
 * data 与 object 顶层声明的统一 AST 节点。
 *
 * 与旧 data 节点的关系：本节点是其超集。
 * - kind = ClassKind.DATA：兼容旧 `data "Name" { fields }` 语法
 * - kind = ClassKind.OBJECT：Stage 7 引入的 object 单例（当前 parser 暂未生产）
 * - funs / nestedClasses：分别由 Stage 6 / Stage 8 接入，Stage 2 一律为空列表
 *
 * Stage 2 仅做"AST 平迁"，runtime / IR / 序列化层均不感知 ClassDecl，
 * 所有依赖 [ScreenAst.classDecls] 的代码沿用与 DataField 一致的字段访问。
 */
data class ClassDecl(
    val name: String,
    val kind: ClassKind,
    val fields: List<DataField>,
    val funs: List<FunDecl> = emptyList(),
    val nestedClasses: List<ClassDecl> = emptyList(),
    override val position: SourcePosition,
) : AstNode

/** [ClassDecl] 的种类：DATA = 值对象、OBJECT = 单例。 */
enum class ClassKind { DATA, OBJECT }

/**
 * 取 [ScreenAst.classDecls] 中 [ClassKind.DATA] 子集。
 *
 * 现有"只关心 data"的语义/管线代码统一通过本扩展取数据类，
 * 避免在多处散落 `.filter { it.kind == ClassKind.DATA }`，
 * 并为 Stage 7 引入 [ClassKind.OBJECT] 后留出唯一过滤口。
 */
fun ScreenAst.dataClassDecls(): List<ClassDecl> =
    classDecls.filter { it.kind == ClassKind.DATA }
